<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="fullTable-wrapper no-footer">
    <div v-if="enablePagination || enableSearch" class="fullTable-top row justify-content-between p-0 mb-4">
      <div v-if="enablePagination" class="fullTable-dropdown col-lg-9" :class="!enableSearch ? 'col-lg-12' : ''">
        <entries-per-page :options="pagination.entries" :current="pagination.rows" @change="onEntriesChange"></entries-per-page>
      </div>
      <div class="col-lg-3 container p-0">
        <div class="row w-100 p-0">
          <div v-if="enableSearch" class="col-lg-5 fullTable-button">
            <reload @change="onReloadClick"></reload>
          </div>
          <div v-if="enableSearch" class="col-lg-7 fullTable-search p-0">
            <searchable :listFilters="listFilters" @change="onSerchableChange"></searchable>
          </div>
        </div>
      </div>
    </div>
    <div class="fullTable-container">
      <table id="genericTable" ref="genericTable" class="table table-flush dataTable-table p-0">
        <thead class="thead-light">
          <Header :headers="headers" :listFilters="listFilters" @changed-header="onHeaderSort"></Header>
        </thead>
        <tbody ref="genericTableBody">
          <tr v-for="(
                      item,
                      index
                    ) of items" :key="index">
            <slot name="row" v-bind="item"></slot>
          </tr>
          <!-- tr class="">
            <td :colspan="items.length" class="text-center">
              <div class="spinner-border m-4 justify-content-center" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </td>
          </tr-->
        </tbody>
      </table>
    </div>
    <div v-if="enablePagination" class="fullTable-bottom">
      <div class="fullTable-info">
        <pagination-info :current="pagination.currentPage" :total="pagination.total"
          :rows="pagination.rows"></pagination-info>
      </div>
      <div class="fullTable-pagination">
        <pagination color="primary" size="md" :total="totalPages" :current="pagination.currentPage"
          :onChanged-page="selectPage">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>

  import Pagination from "./Pagination.vue";
  import PaginationInfo from "./PaginationInfo.vue";
  import EntriesPerPage from "./EntriesPerPage.vue";
  import Searchable from "./Searchable.vue";
  import Header from "./Header.vue";
  import Reload from "./Reload.vue";



  export default {
    name: "FullTable",
    components: {
      Pagination,
      PaginationInfo,
      EntriesPerPage,
      Searchable,
      Header,
      Reload
    },
    props: {
      listFilters: {
        type: Object,
        default: null,
      },
      items: {
        type: Array,
        default: null,
      },
      pagination: {
        type: Object,
        default: () => ({
          total: 200,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1,
          },
          entries: [5, 10, 15, 20]
        })
      },
      enablePagination: {
        type: Boolean,
        default: true
      },
      enableSearch: {
        type: Boolean,
        default: true
      },
      headers:{
        type: Array,
        default: () => ([
          {
            title: "",
            sort: false,
          }
          ])
      }
    },
    emits: ['changed-page', 'row-change', 'search-change','header-change', 'reload-clicked'],
    computed: {
      totalPages() {
        return Math.ceil(this.pagination.total / this.pagination.rows);
      }
    },
    watch: {
      items() {
        let table = this.$refs.genericTable
        table.classList.remove('loading')
      }
    },
    methods: {
      selectPage(index) {
        this.$emit('changed-page', index);
      },
      onSerchableChange(val) {
        this.$emit('search-change', val);
      },
      onEntriesChange(val) {
        this.$emit('row-change', val);
      },
      onHeaderSort(val){
        this.$emit('header-change', val);
      },
      onReloadClick(){
        let table = this.$refs.genericTable
        table.classList.add('loading')
        if (this.items.length <= 2 ) {
          table.style.setProperty('--size', '40px 40px');
        } else {
          table.style.setProperty('--size', '70px 70px');
        }
        this.$emit('reload-clicked');
      }
    }
  };

</script>

<style scoped>

  table.loading tbody {
    position: relative;
  }

  table.loading tbody:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    background-image: url('../../../assets/img/spinner2.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: var(--size);
    content: "";
  }

</style>